import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classNames from "classnames";

import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../../../components/Text";
import Countdown, { zeroPad } from "react-countdown";
import {
  getCollectionList,
  getImageBanner,
} from "../../../actions/kafairAction";
import moment from "moment";
import { normalizeBrand } from "../../../utils/Helpers";
import { getCloudImageUrl, emptyImage } from "../../../utils";

import FanImg from "../../../images/kipas.png";
import emptySneakerImg from "../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../images/emptyhandbags.png";

import styled from "styled-components";

// Arrow
import RaffleGoodDayNext from "../../../images/bca-raffle-arrow-right.png";
import RaffleGoodDayPrev from "../../../images/bca-raffle-arrow-left.png";
import RaffleHolidayNext from "../../../images/bca-raffle-arrow-right.png";
import RaffleHolidayPrev from "../../../images/bca-raffle-arrow-left.png";

const goldenTicket = require("../../../images/golden-ticket.png");
const standardTicket = require("../../../images/standard-ticket.png");

function NextArrow(props) {
  const { className, style, onClick, category } = props;
  const RightArrow = styled.div`
    &::before {
      content: "" !important;
    }
  `;
  const RightSliderIcon = () => {
    switch (category) {
      case "holiday-raffle":
        return RaffleHolidayNext;
      default:
        return RaffleGoodDayNext;
    }
  };
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={RightSliderIcon()}
        alt="..."
        className="slider-arrow arrow-right"
      />
    </RightArrow>
  );
}

function PreviousArrow(props) {
  const { className, style, onClick, category } = props;
  const LeftArrrow = styled.div`
    &::before {
      content: "" !important;
    }
  `;
  const LeftSliderIcon = () => {
    switch (category) {
      case "holiday-raffle":
        return RaffleHolidayPrev;
      default:
        return RaffleGoodDayPrev;
    }
  };
  return (
    <LeftArrrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={LeftSliderIcon()}
        alt="..."
        className="slider-arrow arrow-left"
      />
    </LeftArrrow>
  );
}

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (days !== 0) {
    return (
      <p>
        Ends In <span>{days}</span> days <span>{hours}</span> hours
      </p>
    );
  } else if (hours !== 0) {
    return (
      <p>
        Ends In <span>{hours}</span> hours <span>{minutes}</span> minutes
      </p>
    );
  } else {
    return (
      <p>
        Ends In <span>{minutes}</span> minutes <span>{seconds}</span> seconds
      </p>
    );
  }
};

const IconWrapper = styled.div`
  font-size: 16px;
  color: #1960ae;
  cursor: pointer;
  margin-left: 4px;
  cursor: pointer;
`;

class RaffleNovembazar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "sneakers",
      color: "#fff",
      previewSettings: {
        arrows: true,
        infinite: false,
        speed: 500,
        lazyLoad: true,
        dots: false,
        swipe: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 1281,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
        ],
        nextArrow: <NextArrow category={this.props.imageClass} />,
        prevArrow: <PreviousArrow category={this.props.imageClass} />,
      },
    };
  }

  componentDidMount() {
    this.setState({ color: this.props.color });
  }

  renderProducts = () => {
    const { category } = this.state;
    let { products, group_name, dataChildren, children } = this.props;

    const productLength = products ? products.length : 0;
    const childrenProducts =
      (children &&
        dataChildren[children.query] &&
        dataChildren[children.query].products) ||
      [];
    let newProducts = products;
    if (childrenProducts.length > 0 && products && products.length > 0) {
      newProducts = [...childrenProducts, ...products];
    }

    return (
      <a href={`/bcaxkickavenue/raffle/${group_name}`}>
        <div className="d-none d-sm-block">
          {newProducts && newProducts.length > 0 ? (
            <Thumbnails
              settings={{
                ...this.state.previewSettings,
                slidesToShow: Math.min(productLength, 4),
              }}
              afterChange={this.changeImage}
              beforeChange={this._handleBeforeChange}
              thumbnails={newProducts.map((item) => {
                return {
                  id: item.id,
                  slug: `bcaxkickavenue/raffle/${group_name}`,
                  img: item.image
                    ? getCloudImageUrl(item.image, 400)
                    : emptyImage(category),
                  display_name: item.display_name,
                  brand: item.brand && item.brand.flat[0],
                  price: item.price,
                  out_of_stock: item.out_of_stock,
                  category,
                };
              })}
              active={this.state.currentIndex}
              renderItems={(newProducts) =>
                this._renderItems(category, newProducts)
              }
              lengthShow={4}
            />
          ) : null}
        </div>
        <div className="d-block d-sm-none">
          {newProducts && newProducts.length > 0 ? (
            <Thumbnails
              settings={{
                ...this.state.previewSettings,
                slidesToShow: 1,
              }}
              afterChange={this.changeImage}
              beforeChange={this._handleBeforeChange}
              thumbnails={newProducts.map((item) => {
                return {
                  id: item.id,
                  slug: `bcaxkickavenue/raffle/${group_name}`,
                  img: item.image
                    ? getCloudImageUrl(item.image, 400)
                    : emptyImage(category),
                  display_name: item.display_name,
                  brand: item.brand && item.brand.flat[0],
                  price: item.price,
                  out_of_stock: item.out_of_stock,
                  category,
                };
              })}
              active={this.state.currentIndex}
              renderItems={(newProducts) =>
                this._renderItems(category, newProducts)
              }
              lengthShow={1}
            />
          ) : null}
        </div>
      </a>
    );
  };

  _renderItems(category, data) {
    const { start_date } = this.props;
    const isStart = moment().isAfter(start_date);

    return data.map((item, index) => (
      <div key={index} className="sneaker-item">
        <div
          className={classNames("product-card")}
          onClick={this.goToRaffleDetail}
          style={{ cursor: "pointer" }}
        >
          <div
            className={classNames("sneaker-item__text", {
              disabled: !item.price || item.out_of_stock || !isStart,
            })}
          >
            <p>{item.brand ? normalizeBrand(item.brand) : null}</p>
            <div className="display-name-container">
              <p>{item.display_name}</p>
            </div>
          </div>
          <KickImage
            alt={item.display_name}
            src={item.img}
            className={classNames("sneaker-item__image", {
              disabled: !item.price || item.out_of_stock || !isStart,
            })}
          />
          {item.price ? (
            <TextRupiah
              value={item.price}
              className="price-tag"
              color="black"
              bold={true}
              align="center"
              disabled={!item.price || item.out_of_stock || !isStart}
              isFormatRupiah
            />
          ) : (
            <span className="text-center red">Out of stock</span>
          )}
        </div>
      </div>
    ));
  }

  renderTimer = ({ days, hours, minutes, seconds, completed }) => {
    const { name, color } = this.state;

    if (completed) {
      return (
        <div className={classNames("countdown-wrapper")}>
          <span style={{ backgroundColor: color }}>{zeroPad(days)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(hours)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(minutes)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(seconds)}</span>
        </div>
      );
    } else {
      return (
        <div className={classNames("countdown-wrapper")}>
          <span style={{ backgroundColor: color }}>{zeroPad(days)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(hours)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(minutes)}</span>
          <span style={{ color: color }}>:</span>
          <span style={{ backgroundColor: color }}>{zeroPad(seconds)}</span>
        </div>
      );
    }
  };

  goToRaffleDetail = () => {
    const { group_name } = this.props;

    window.open(`/bcaxkickavenue/raffle/${group_name}`, "_blank");
  };

  render() {
    const { category } = this.state;
    const {
      isLogged,
      userData,
      title,
      isGolden,
      products,
      start_date,
      expiry_date,
      ticket_name,
      color,
      group_name,
      key,
      ticket_type,
      userRaffleTicket,
      noBorder,
      noTimer,
      containerColor,
      subTitle,
      buttonColor,
      titleColor,
      buttonTitleColor,
      imageClass,
      isNovembazar,
      description,
      background,
      header,
      children,
      dataChildren,
    } = this.props;
    const userTicket =
      userRaffleTicket &&
        userRaffleTicket.data &&
        userRaffleTicket.data[ticket_type]
        ? userRaffleTicket.data[ticket_type].total
        : 0;

    const isStart = moment().isAfter(start_date);
    const isExpired = moment().isAfter(expiry_date);
    const sectionTitle = title ? title.toUpperCase().replace(/\+/gi, " ") : "";
    if (products && products.length > 0) {
      return (
        <Container fluid className="special-deals-section official novembazar">
          <Row className="content-container raffle">
            <Col className="raffle-timer-container">
              <Countdown
                date={expiry_date && moment(expiry_date).format()}
                renderer={renderer}
                daysInHours={true}
              />
              <p>
                Get raffle tickets from every purchase you made. Applicable on
                ALL products in the marketplace.
              </p>
              <div className="information-btn-wrapper" onClick={() => {
                window.open("/helps/bcaxkickavenue", "_blank").focus()
                // this.props.history.push("/helps/bcaxkickavenue")
              }}>
                <p>
                  Exclusive for <span>BCA Payment</span>
                </p>
                <div className="i-icon-wrapper">
                  <span>i</span>
                </div>
              </div>
            </Col>
            <Col className="raffle-header-container" md={12} xs={12}>
              <div className="title-wrapper">
                <div className="left-side">
                  <p className="title official sub">{title}</p>
                </div>
                <div
                  className="button-ticket"
                  style={{ backgroundColor: color, marginTop: "5px", cursor: "default" }}
                >
                  <p>
                    Tickets: <span>{userTicket}</span>
                  </p>
                </div>
              </div>
            </Col>
            <Col id="raffle-product-card-container" md={12} xs={12}>
              <div
                className={classNames(
                  "right-side local-brands official",
                  {
                    white: isGolden,
                  },
                  {
                    maroon: !isGolden,
                  }
                )}
              >
                {this.renderProducts()}
              </div>
            </Col>
            <Col className="raffle-view-all-btn-container" md={12} xs={12}>
              <div className="shop-to-get-product-wrapper">
                <div className="shop-btn-inner-wrapper" onClick={() => this.props.history.push("/search/sneakers/browse+all")}>
                  <p>SHOP to get raffle tickets</p>
                </div>
              </div>
              <div className="button-wrapper">
                <div
                  className="left-side button"
                  style={{
                    cursor:
                      imageClass !== "holiday-raffle" ? "pointer" : "default",
                  }}
                  onClick={
                    imageClass !== "holiday-raffle"
                      ? this.goToRaffleDetail
                      : null
                  }
                >
                  <p
                    className="title official center"
                    style={{ color: titleColor, marginTop: 0 }}
                    onClick={this.goToRaffleDetail}
                  >
                    View Raffles
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  isLogged: state.dataAuth.isLogged,
  userData: state.dataAuth.userdata,
  data: state.dataKaFair.special_deals,
  userRaffleTicket: state.dataKaFair.userRaffleTicket,
  dataChildren: state.dataKaFair.raffle,
});

const StyledArrow = styled.div`
  &::after {
    font-size: 40px;
  }
  &::before {
    font-size: 40px;
  }
`;

const mapDispatchToProps = (dispatch) => ({
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RaffleNovembazar);
